"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LootTable_1 = __importDefault(require("../../../../structures/LootTable"));
const SimpleMonster_1 = __importDefault(require("../../../../structures/SimpleMonster"));
const RareDropTable_1 = require("../../../subtables/RareDropTable");
const GreaterDemonTable = new LootTable_1.default({ limit: 128 })
    .every('Ashes')
    /* Weapons and armor */
    .add('Steel 2h sword', 1, 4)
    .add('Steel axe', 1, 3)
    .add('Steel battleaxe', 1, 3)
    .add('Mithril kiteshield', 1, 1)
    .add('Adamant platelegs', 1, 1)
    .add('Rune full helm', 1, 1)
    /* Runes and ammunition */
    .add('Fire rune', 75, 8)
    .add('Chaos rune', 15, 3)
    .add('Fire rune', 37, 1)
    .add('Death rune', 5, 3)
    /* Coins */
    .add('Coins', 132, 40)
    .add('Coins', 44, 29)
    .add('Coins', 220, 10)
    .add('Coins', 11, 7)
    .add('Coins', 460, 1)
    /* Other */
    .add('Tuna', 1, 3)
    .add('Gold bar', 1, 2)
    .add('Thread', 10, 1)
    /* RDT */
    .add(RareDropTable_1.GemTable, 1, 5)
    /* Tertiary */
    .tertiary(40, 'Ensouled demon head')
    .tertiary(128, 'Clue scroll (hard)');
exports.default = new SimpleMonster_1.default({
    id: 2025,
    name: 'Greater Demon',
    table: GreaterDemonTable,
    aliases: ['greater demon', 'greater', 'greaters']
});
//# sourceMappingURL=GreaterDemon.js.map